export default "__VITE_ASSET__uxy4H1Of__"